import Vue from 'vue'
export const clientBlackPagiation = {
  namespaced: true,
  state: () => ({
    paginationClientBlackStateParams: {
      count: 0,
      limit: 100,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationClientBlackStateParams.total /
          state.paginationClientBlackStateParams.limit
      )
  },
  mutations: {
    update_pagination(state, { total, count, limit, page }) {
      state.paginationClientBlackStateParams = { total, count, limit, page }
    }
  },
  actions: {
    getClientBlackAll({ commit }, pagination) {
      commit('update_pagination', pagination)
    }
  }
}
